import VariantSelector from '../modules/variant-selector.js';
import '../vendor/online-sizing.js';
import onDocumentReady from '../utils/on-document-ready.js';

onDocumentReady(() => {
  const variantSelector = document.querySelector('[data-variant-selector]');

  if (variantSelector) {
    const initialSelector = new VariantSelector(variantSelector);
    initialSelector.loadInInitialVariant();
  }
});

// Re-initialise the size guide trigger
if (window.oz && window.oz.initTriggers) {
  window.oz.initTriggers([document.querySelector('[data-oz-trigger]')]);
}

document.addEventListener('scroll', () => {
  const mobileProductBar = document.querySelector('.mobile-product-nav-bar');
  const scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop;

  if (scrollTop >= mobileProductBar.getBoundingClientRect().height) {
    mobileProductBar.classList.remove('opacity-0');
  } else {
    mobileProductBar.classList.add('opacity-0');
  }
});

document.addEventListener('section:product-top:reload', () => {
  const variantSelector = document.querySelector('[data-variant-selector]');

  if (variantSelector) {
    // eslint-disable-next-line no-new
    new VariantSelector(document.querySelector('[data-variant-selector]'));
  }

  // Re-initialise the size guide trigger
  if (window.oz && window.oz.initTriggers) {
    window.oz.initTriggers([document.querySelector('[data-oz-trigger]')]);
  }
});
